import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/coingroup/financial-system/backoffice/layouts/default.vue").then(m => m.default || m))
}